import { c as _c } from "react-compiler-runtime";
import { useEffect, useMemo } from 'react';
import useCollaborationSidebarState from '../../../hooks/useCollaborationSidebarState';
export function useEmbeddedCommentPopover(t0) {
  "use memo";

  var _referenceElement;
  const $ = _c(16);
  const {
    iframeContainerID,
    popoverContentWrapperRef,
    closeEmbeddedCommentPopover
  } = t0;
  const {
    commentableAreaClickCoordinates,
    isEmbeddedPopoverOpen,
    embeddedCommentCoordinates,
    embeddedPopoverAnchorSelector
  } = useCollaborationSidebarState();
  let t1;
  let referenceElement;
  if (embeddedPopoverAnchorSelector) {
    referenceElement = document.querySelector(embeddedPopoverAnchorSelector);
  } else {
    if (iframeContainerID) {
      referenceElement = document.getElementById(iframeContainerID);
    }
  }
  const referenceRect = (_referenceElement = referenceElement) === null || _referenceElement === void 0 ? void 0 : _referenceElement.getBoundingClientRect();
  if (isEmbeddedPopoverOpen) {
    const t2 = referenceRect ? embeddedCommentCoordinates.top + referenceRect.top : embeddedCommentCoordinates.top;
    const t3 = referenceRect ? embeddedCommentCoordinates.left + referenceRect.left : embeddedCommentCoordinates.left;
    let t4;
    if ($[0] !== embeddedCommentCoordinates.height || $[1] !== embeddedCommentCoordinates.width || $[2] !== t2 || $[3] !== t3) {
      t4 = {
        top: t2,
        left: t3,
        width: embeddedCommentCoordinates.width,
        height: embeddedCommentCoordinates.height
      };
      $[0] = embeddedCommentCoordinates.height;
      $[1] = embeddedCommentCoordinates.width;
      $[2] = t2;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t1 = t4;
  } else {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      };
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = t2;
  }
  const dimensionsAndCoordinates = t1;
  let t2;
  let t3;
  if ($[6] !== closeEmbeddedCommentPopover || $[7] !== commentableAreaClickCoordinates || $[8] !== embeddedPopoverAnchorSelector || $[9] !== iframeContainerID || $[10] !== isEmbeddedPopoverOpen || $[11] !== popoverContentWrapperRef) {
    t2 = () => {
      var _popoverContentWrappe, _referenceElement_;
      if (!isEmbeddedPopoverOpen || !commentableAreaClickCoordinates) {
        return;
      }
      const popoverRect = (_popoverContentWrappe = popoverContentWrapperRef.current) === null || _popoverContentWrappe === void 0 ? void 0 : _popoverContentWrappe.getBoundingClientRect();
      let referenceElement_0;
      if (embeddedPopoverAnchorSelector) {
        referenceElement_0 = document.querySelector(embeddedPopoverAnchorSelector);
      } else {
        if (iframeContainerID) {
          referenceElement_0 = document.getElementById(iframeContainerID);
        }
      }
      const referenceRect_0 = (_referenceElement_ = referenceElement_0) === null || _referenceElement_ === void 0 ? void 0 : _referenceElement_.getBoundingClientRect();
      const absoulteCoordinates = {
        x: commentableAreaClickCoordinates.x + ((referenceRect_0 === null || referenceRect_0 === void 0 ? void 0 : referenceRect_0.left) || 0),
        y: commentableAreaClickCoordinates.y + ((referenceRect_0 === null || referenceRect_0 === void 0 ? void 0 : referenceRect_0.top) || 0)
      };
      if (popoverRect && commentableAreaClickCoordinates) {
        if (absoulteCoordinates.x < popoverRect.left || absoulteCoordinates.x > popoverRect.right || absoulteCoordinates.y < popoverRect.top || absoulteCoordinates.y > popoverRect.bottom) {
          closeEmbeddedCommentPopover();
        }
      }
    };
    t3 = [isEmbeddedPopoverOpen, commentableAreaClickCoordinates, closeEmbeddedCommentPopover, iframeContainerID, popoverContentWrapperRef, embeddedPopoverAnchorSelector];
    $[6] = closeEmbeddedCommentPopover;
    $[7] = commentableAreaClickCoordinates;
    $[8] = embeddedPopoverAnchorSelector;
    $[9] = iframeContainerID;
    $[10] = isEmbeddedPopoverOpen;
    $[11] = popoverContentWrapperRef;
    $[12] = t2;
    $[13] = t3;
  } else {
    t2 = $[12];
    t3 = $[13];
  }
  useEffect(t2, t3);
  let t4;
  if ($[14] !== dimensionsAndCoordinates) {
    t4 = {
      dimensionsAndCoordinates
    };
    $[14] = dimensionsAndCoordinates;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}